import { useQuery } from '@tanstack/react-query'
import { useSession } from '~/components/user/SessionProvider'
import { getInvoiceDetails } from '~/data/invoices/readInvoices'

export function useInvoices() {
  const { session } = useSession()

  return useQuery({
    queryKey: ['invoices', session?.user.id],
    queryFn: () => session && getInvoiceDetails(session.user.id),
    enabled: !!session,
  })
}
